import { DataModelBase } from '@/core/collections/modelBase';

export default class Character extends DataModelBase {
    _character_version = 1;
    _id: string | undefined = undefined;
    name = '';
    description = '';
    image = '';
    borderMode = 'square';
    borderColor = '';
    tokenSize = 1;
    icon: string | null = '';
    private = false;
    macros: unknown[] = [];
    version = '0.0.0';

    /** Reconstructs a stored record field for field; the fields above are new-character defaults. */
    constructor(jsonObject?: Record<string, unknown> | null) {
        super();
        if (!jsonObject) return;
        Object.assign(this, jsonObject);
    }
}
